import { useState, useEffect } from 'react'

export const useHasScrolled = () => {
  const [hasScrolled, setHasScrolled] = useState(false)
  useEffect(() => {
    const onScroll = () => {
      /* istanbul ignore else */
      if (window.scrollY > 0) {
        setHasScrolled(true)
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return hasScrolled
}
